import type { RouteRecordRaw } from 'vue-router'

/**
 * Public route for Ops-Console impersonation handoff.
 *
 * The console opens:
 *   https://<subdomain>.<base>/login-as#access_token=<TOKEN>&subdomain=<SUB>
 *
 * The token is passed in the URL **fragment** (after #) so it never reaches
 * any server log. LoginAs.vue reads it client-side, writes the auth cookie,
 * strips the fragment, and redirects into the app.
 *
 * This route must be PUBLIC — no auth guard. It is deliberately excluded from
 * the login parent route (which has a `beforeEnter` that redirects logged-in
 * users to the dashboard) so that a currently-authenticated user can still be
 * handed a new impersonation session.
 */
export const loginAs: RouteRecordRaw = {
	name: 'loginAs',
	path: '/login-as',
	component: () =>
		import('@/components/modules/Login/LoginAs.vue'),
	meta: {
		title: 'Anmeldung als Benutzer',
	},
}
